import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles({
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '0.5rem 1rem',
  },

  icon: { marginRight: '0.5rem' },

  breakdown: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0 1.5rem',
    margin: '0.25rem 0 0 1.5rem',
    padding: 0,
    listStyle: 'none',
    fontSize: '0.9em',
  },
})
